var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parand mr-3",staticStyle:{"font-size":"1.10rem"}},[_vm._v(" "+_vm._s(_vm.date)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }